import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useEffect } from 'react';
import { IconButton, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Close } from '@material-ui/icons';
var duration = 15000;

var ToastController = function ToastController(_ref) {
  var e2e = _ref.e2e,
      severity = _ref.severity,
      message = _ref.message;
  var queueRef = React.useRef([]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      messageInfo = _React$useState4[0],
      setMessageInfo = _React$useState4[1];

  var _React$useState5 = React.useState(duration),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      autoHideDuration = _React$useState6[0],
      setAutoHideDuration = _React$useState6[1];

  var processQueue = function processQueue() {
    if (queueRef.current.length > 0) {
      setMessageInfo(queueRef.current.shift());
      setOpen(true);
    }
  };

  useEffect(function () {
    if (!message) {
      return;
    }

    queueRef.current.push({
      message: message,
      severity: severity,
      key: new Date().getTime()
    });

    if (open) {
      // immediately begin dismissing current message
      // to start showing new one
      setOpen(false);
    } else {
      processQueue();
    }
  }, [message, severity]);

  var handleClose = function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  var handleExited = function handleExited() {
    processQueue();
  };

  var handleHover = function handleHover() {
    setAutoHideDuration(null);
  };

  var handleHoverEnd = function handleHoverEnd() {
    setAutoHideDuration(duration);
  };

  return /*#__PURE__*/React.createElement(Snackbar, _extends({}, e2e && {
    'data-e2e': e2e
  }, {
    key: (messageInfo === null || messageInfo === void 0 ? void 0 : messageInfo.key) || undefined,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: open,
    autoHideDuration: autoHideDuration,
    onClose: handleClose,
    onExited: handleExited,
    onMouseEnter: handleHover,
    onMouseLeave: handleHoverEnd,
    transitionDuration: 100
  }), /*#__PURE__*/React.createElement(Alert, {
    severity: (messageInfo === null || messageInfo === void 0 ? void 0 : messageInfo.severity) || 'info',
    onClose: handleClose,
    action: /*#__PURE__*/React.createElement(IconButton, _extends({
      color: "inherit",
      size: "small",
      "aria-label": "Close",
      title: "Close",
      onClick: handleClose
    }, e2e && {
      'data-e2e': "".concat(e2e, "-close")
    }), /*#__PURE__*/React.createElement(Close, null))
  }, messageInfo ? messageInfo.message : undefined));
};

export default ToastController;

try {
  ToastController.__docgenInfo = {
    description: '',
    displayName: 'ToastController',
    methods: [],
    props: {
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      message: {
        defaultValue: null,
        description: '',
        name: 'message',
        required: true,
        type: {
          name: 'string'
        }
      },
      severity: {
        defaultValue: null,
        description: 'The severity of the alert. This defines the color and icon used.',
        name: 'severity',
        required: false,
        type: {
          name: 'enum',
          raw: 'Color',
          value: [{
            value: '"success"'
          }, {
            value: '"info"'
          }, {
            value: '"warning"'
          }, {
            value: '"error"'
          }]
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map